export const Endpoint = () => `/api/v3/admin/forgetuser/`;
export const Csrf = () => `/api/v3/admin/token/`;

export interface Payload {
    id: string;
}

export type Response = void;
